import { GridEntity, type IGridRowData } from "commonComponents/utilities/Grid/GridContainer.types";
import { type ITaxGroupLinkResponse } from "commonComponents/utilities/Grid/taxGroups/columnImplementations/columnTaxGroupLink";

import { type TaxGroupServiceListItemExtraData } from "../../../commonComponents/financial/TaxRateSelect/TaxRateSelect.api.types";
import {
    type BTSelectItem,
    mapBTServiceDropdownToSelectItem,
} from "../../../types/apiResponse/apiResponse";
import type { default as TaxGroupListJson } from "./TaxGroupList.api.json";

export type TaxGroupListFormActions = "newTaxGroup" | "checkedAction" | undefined;

export class TaxGroupGridEntity extends GridEntity {
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(data: typeof TaxGroupListJson) {
        super(data);
        // TODO: handle permission logic here
    }
}

export interface ITaxGroupGridListItem extends IGridRowData {
    id: number;
    isApplied: boolean;
    taxGroupLink: ITaxGroupLinkResponse;
}
export class TaxGroups {
    constructor(data: any) {
        this.taxGroups = data
            ? (mapBTServiceDropdownToSelectItem<TaxGroupServiceListItemExtraData>(data)[0]
                  ?.children ?? [])
            : [];
    }
    taxGroups: BTSelectItem<TaxGroupServiceListItemExtraData>[];
}
export const taxGroupNameColumnId = "1";
export const taxGroupNameColumnWidth = 309;
